import React__default from 'react';
import './progress.css.js';

function ProgressIndicator({ variant = "linear", value, size = 80, strokeWidth = 8, color = "#6750A4", trackColor = "#e0e0e0", showLabel = true, }) {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;
    if (variant === "circle") {
        return (React__default.createElement("div", { className: "progress-circle-wrapper", style: { width: size, height: size } },
            React__default.createElement("svg", { className: "progress-circle", viewBox: `0 0 ${size} ${size}` },
                React__default.createElement("circle", { className: "progress-circle-track", cx: size / 2, cy: size / 2, r: radius, strokeWidth: strokeWidth, stroke: trackColor, fill: "none" }),
                React__default.createElement("circle", { className: "progress-circle-bar", cx: size / 2, cy: size / 2, r: radius, strokeWidth: strokeWidth, stroke: color, fill: "none", strokeDasharray: circumference, strokeDashoffset: offset })),
            showLabel && React__default.createElement("div", { className: "progress-circle-label" },
                value,
                "%")));
    }
    // Linear variant
    return (React__default.createElement("div", { className: "progress-linear-wrapper" },
        React__default.createElement("div", { className: "progress-linear-track" },
            React__default.createElement("div", { className: "progress-linear-bar", style: {
                    width: `${value}%`,
                    background: `linear-gradient(90deg, ${color}, #9575cd)`,
                } })),
        showLabel && React__default.createElement("span", { className: "progress-linear-label" },
            value,
            "%")));
}

export { ProgressIndicator };
//# sourceMappingURL=ProgressIndicator.js.map
